import { configureStore } from '@reduxjs/toolkit';
import installReducer from './slices/installSlice';
import campaignReducer from './slices/campaignSlice';
import settingsReducer from './slices/settingsSlice';
import appReducer from './slices/appSlice';
import { checkInstall } from './slices/installSlice';

/**
 * Redux Store Configuration
 * - Combines all reducers
 * - Configures middleware for serialization checks
 * - Dispatches install check on initialization
 */
export const store = configureStore({
  reducer: {
    install: installReducer,
    campaign: campaignReducer,
    settings: settingsReducer,
    app: appReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          'install/checkInstall/fulfilled',
          'campaign/fetchCampaigns/fulfilled',
          'campaign/fetchFilteredCampaigns/fulfilled',
        ],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state (Date objects in campaigns)
        ignoredPaths: [
          'install.installData',
          'campaign.campaigns',
          'campaign.filteredCampaigns',
        ],
      },
    }),
});

// Dispatch install check immediately when store is created
// This ensures the install API is called first before any components mount
// The checkInstall thunk will automatically skip API call if data already exists in Redux
store.dispatch(checkInstall());
